/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Related_TitleInputs */

const en_directory_ai_tools_related_title = /** @type {(inputs: Directory_Ai_Tools_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare other AI rap and music video tools`)
};

const zh_directory_ai_tools_related_title = /** @type {(inputs: Directory_Ai_Tools_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比其他 AI 说唱与音乐视频工具`)
};

/**
* | output |
* | --- |
* | "Compare other AI rap and music video tools" |
*
* @param {Directory_Ai_Tools_Related_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_related_title = /** @type {((inputs?: Directory_Ai_Tools_Related_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Related_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_related_title(inputs)
	return zh_directory_ai_tools_related_title(inputs)
});
export { directory_ai_tools_related_title as "directory.ai_tools.related_title" }